var WorkerPool = require('./worker-pool');

const pools = {};

module.exports = function(src) {
	if (!pools[src]) {
		pools[src] = new WorkerPool(src);
	}

	const pool = pools[src];

	return function() {
		var _t = this;

		this.oncomplete = on(this, 'complete');
		this.progress = on(this, 'progress');

		this.run = function() {
			this.args = Array.prototype.slice.call(arguments, 0);
			pool.run(this);
			return this;
		};

		this.and = function(callback) {
			_t.oncomplete.and(callback);
			return this;
		};
		this.then = this.and

		this.onprogress = function(callback) {
			_t.progress.and(callback);
			return this;
		};

	};
};